// Contains DataFrame merge logic, similar to //perf/go/dataframe/dataframe.go
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    range: function() {
        return range;
    },
    findSubDataframe: function() {
        return findSubDataframe;
    },
    generateSubDataframe: function() {
        return generateSubDataframe;
    },
    mergeAnomaly: function() {
        return mergeAnomaly;
    },
    removeAnomaly: function() {
        return removeAnomaly;
    },
    findAnomalyInRange: function() {
        return findAnomalyInRange;
    },
    mergeColumnHeaders: function() {
        return mergeColumnHeaders;
    },
    join: function() {
        return join;
    },
    buildParamSet: function() {
        return buildParamSet;
    },
    timestampBounds: function() {
        return timestampBounds;
    }
});
const _json = require("../json");
const _paramtools = require("../paramtools");
const _const = require("../const/const");
const range = (begin, end)=>({
        begin,
        end
    });
const findSubDataframe = (header, range, domain = 'timestamp')=>{
    const prop = domain === 'date' || domain === 'timestamp' ? 'timestamp' : 'offset';
    const begin = header.findIndex((v)=>{
        return range.begin <= v[prop];
    });
    const end = header.findIndex((v)=>{
        return range.end < v[prop];
    });
    return {
        begin: begin < 0 ? header.length : begin,
        end: end < 0 ? header.length : end
    };
};
const generateSubDataframe = (dataframe, range)=>{
    return {
        header: dataframe.header.slice(range.begin, range.end),
        traceset: Object.fromEntries(Object.keys(dataframe.traceset).map((k)=>[
                k,
                dataframe.traceset[k].slice(range.begin, range.end)
            ])),
        skip: 0,
        paramset: (0, _json.ReadOnlyParamSet)({}),
        // Maybe we can trim this to only the commits in the range.
        traceMetadata: dataframe.traceMetadata
    };
};
const mergeAnomaly = (anomaly1, ...anomalies)=>{
    const anomaly = structuredClone(anomaly1 || {});
    if (anomalies.length <= 0) {
        return structuredClone(anomaly1 || {});
    }
    /**
   * {
   *  ',trace=key1': {
   *    commit_position1: Anomaly 1,
   *    commit_position2: Anomaly 2,
   *    ...
   *  },
   *  `,trace=key2': {...}
   * }
   */ anomalies.forEach((anomaly2)=>{
        for(const trace in anomaly2){
            // Merge the anomaly from anomaly2 for the trace.
            // First we use the existing merged anomaly as the base, and then add
            // or update the anomaly data at each commit.
            const commitAnomaly = anomaly[trace] || {};
            const commitAnomaly2 = anomaly2[trace];
            // In each trace, the anomaly is in the sparsed array, so it's more
            // efficient to iterater using keys.
            for(const commit in commitAnomaly2){
                const commitNum = Number(commit);
                // The anomaly at commitNum will either be overridden and added to the
                // anomaly for the current trace.
                commitAnomaly[commitNum] = commitAnomaly2[commitNum];
            }
            // Override with the updated anomaly for the trace.
            anomaly[trace] = commitAnomaly;
        }
    });
    return anomaly;
};
const removeAnomaly = (anomalies, id)=>{
    const anomaly = {};
    for(const trace in anomalies){
        const commitAnomaly = {};
        const traceAnomaly = anomalies[trace];
        for(const commit in traceAnomaly){
            const commitNum = Number(commit);
            // Check that the nudged commit number is found, then skip adding back in.
            if (traceAnomaly[commitNum].id !== id) {
                commitAnomaly[commitNum] = traceAnomaly[commitNum];
            }
        }
        if (Object.keys(commitAnomaly).length > 0) {
            anomaly[trace] = commitAnomaly;
        }
    }
    return anomaly;
};
const findAnomalyInRange = (allAnomaly, range)=>{
    const anomaly = {};
    for(const trace in allAnomaly){
        const commitAnomaly = {};
        const traceAnomaly = allAnomaly[trace];
        for(const commit in traceAnomaly){
            const commitNum = Number(commit);
            if (commitNum >= range.begin && commitNum <= range.end) {
                commitAnomaly[commitNum] = traceAnomaly[commitNum];
            }
        }
        if (Object.keys(commitAnomaly).length > 0) {
            anomaly[trace] = commitAnomaly;
        }
    }
    return anomaly;
};
function mergeColumnHeaders(a, b) {
    if (a === null || a.length === 0) {
        return [
            b,
            simpleMap(0),
            simpleMap(b.length)
        ];
    }
    if (b === null || b.length === 0) {
        return [
            a,
            simpleMap(a.length),
            simpleMap(0)
        ];
    }
    const aMap = {};
    const bMap = {};
    const numA = a.length;
    const numB = b.length;
    let pA = 0;
    let pB = 0;
    const ret = [];
    for(; true;){
        if (pA === numA && pB === numB) {
            break;
        }
        if (pA === numA) {
            // Copy in the rest of B.
            for(let i = 0; i < numB; i++){
                bMap[i] = ret.length;
                ret.push(b[i]);
            }
            break;
        }
        if (pB === numB) {
            // Copy in the rest of A.
            for(let i = pA; i < numA; i++){
                aMap[i] = ret.length;
                ret.push(a[i]);
            }
            break;
        }
        if (a[pA].offset < b[pB].offset) {
            aMap[pA] = ret.length;
            ret.push(a[pA]);
            pA += 1;
        } else if (a[pA].offset > b[pB].offset) {
            bMap[pB] = ret.length;
            ret.push(b[pB]);
            pB += 1;
        } else {
            aMap[pA] = ret.length;
            bMap[pB] = ret.length;
            ret.push(a[pA]);
            pA += 1;
            pB += 1;
        }
    }
    return [
        ret,
        aMap,
        bMap
    ];
}
function join(a, b) {
    if (a === null) {
        return b;
    }
    const [header, aMap, bMap] = mergeColumnHeaders(a.header, b.header);
    const ret = {
        header: header,
        traceset: {},
        traceMetadata: null
    };
    if (a.header.length === 0) {
        a.header = b.header;
    }
    ret.skip = b.skip;
    const ps = (0, _json.ParamSet)({});
    (0, _paramtools.addParamSet)(ps, a.paramset);
    (0, _paramtools.addParamSet)(ps, b.paramset);
    normalize(ps);
    ret.paramset = (0, _paramtools.toReadOnlyParamSet)(ps);
    const traceLen = ret.header.length;
    // Pre-allocate the arrays in the traceset with the correct length.
    for (const key of Object.keys(a.traceset)){
        if (!ret.traceset[key]) {
            ret.traceset[key] = new Array(traceLen).fill(_const.MISSING_DATA_SENTINEL);
        }
    }
    for (const key of Object.keys(b.traceset)){
        if (!ret.traceset[key]) {
            ret.traceset[key] = new Array(traceLen).fill(_const.MISSING_DATA_SENTINEL);
        }
    }
    for (const [key, sourceTrace] of Object.entries(a.traceset)){
        const destTrace = ret.traceset[key];
        sourceTrace.forEach((sourceValue, sourceOffset)=>{
            destTrace[aMap[sourceOffset]] = sourceValue;
        });
    }
    for (const [key, sourceTrace] of Object.entries(b.traceset)){
        const destTrace = ret.traceset[key];
        sourceTrace.forEach((sourceValue, sourceOffset)=>{
            destTrace[bMap[sourceOffset]] = sourceValue;
        });
    }
    ret.traceMetadata = [
        ...a.traceMetadata || [],
        ...b.traceMetadata || []
    ];
    return ret;
}
function buildParamSet(d) {
    const paramSet = (0, _json.ParamSet)({});
    for (const key of Object.keys(d.traceset)){
        const params = (0, _paramtools.fromKey)(key);
        (0, _paramtools.addParamsToParamSet)(paramSet, params);
    }
    normalize(paramSet);
    d.paramset = (0, _paramtools.toReadOnlyParamSet)(paramSet);
}
function timestampBounds(df) {
    if (df === null || df.header === null || df.header.length === 0) {
        return [
            NaN,
            NaN
        ];
    }
    const ret = [
        NaN,
        NaN
    ];
    ret[0] = df.header[0].timestamp;
    ret[1] = df.header[df.header.length - 1].timestamp;
    return ret;
}
function normalize(ps) {
    for (const [_, v] of Object.entries(ps)){
        v.sort();
    }
}
function simpleMap(n) {
    const ret = {};
    for(let i = 0; i < n; i += 1){
        ret[i] = i;
    }
    return ret;
}
